export enum ThirdPartyAction {
  PUSH_CHANGES,
  APPROVE_COLLECTION
}
